import { useAuthUserData, useUserOrganisations } from '../authUserProvider'
import { Brand, SENTINEL_BRAND, getBrandForHostname, getBrandForOrg } from './brandingConfig'

// Resolves the active brand.
//
// 1. A dedicated white-label hostname (e.g. dashboard.claimsdirectgroup.com)
//    always wins. This covers pre-login screens — the footer and tab
//    title/favicon shown before the Cognito redirect, where no organisation is
//    known yet — and keeps a domain that exists purely for one white-label
//    consistently branded.
// 2. Otherwise (e.g. the shared Sentinel domain) the brand follows the
//    organisation the user is currently viewing: `activeOrganisation` (the
//    in-session org switcher value), falling back to the raw Cognito
//    `custom:organisation` so the first paint after a hard refresh still
//    resolves correctly.
export function useBranding(): Brand {
    const { activeOrganisation } = useUserOrganisations()
    const authUser = useAuthUserData()

    const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
    const hostnameBrand = getBrandForHostname(hostname)
    if (hostnameBrand.key !== SENTINEL_BRAND.key) return hostnameBrand

    const org = activeOrganisation || authUser?.['custom:organisation'] || ''
    return getBrandForOrg(org)
}
